module.exports = __webpack_public_path__ + "static/media/img3.d6384747.jpeg";